export default "__VITE_ASSET__B$iEuyTe__"